import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoverLetter, defaultCoverLetter } from '../../models/cover-letter.model';
import { CoverLetterComponent } from '../cover-letter/cover-letter.component';
import { JobPostingComponent } from '../job-posting/job-posting.component';
import { TranslationService } from '../../services/translation.service';
import type { ChatBubbleTranslations } from '../../i18n/chat-bubble';
import en from '../../i18n/en/chat-bubble';

@Component({
  selector: 'app-chat-bubble',
  standalone: true,
  imports: [CommonModule, CoverLetterComponent, JobPostingComponent],
  templateUrl: './chat-bubble.component.html',
  styleUrls: ['./chat-bubble.component.css'],
})
export class ChatBubbleComponent {
  @Input() jobPosting: any;
  @Input() jobPostingApplicationId: number | string | null = null;
  @Input() type: string = '';
  @Input() date: string = '';
  @Input() content: string = '';
  coverLetter: CoverLetter = defaultCoverLetter;
  isCopied: boolean = false; // State to handle copied state
  parsedJobPosting: any = null;

  translations: ChatBubbleTranslations = en;

  get t(): ChatBubbleTranslations {
    return this.translations;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService
  ) {
    const current = this.translationService.getChatBubbleTranslations();
    if (current) {
      this.translations = current;
    }
    this.translationService.onChange(() => {
      const next = this.translationService.getChatBubbleTranslations();
      if (next) {
        this.translations = next;
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit() {
    this.parseCoverLetterIfApplicable();
    if (this.type === 'from_assistant_job_posting' && this.content) {
      try {
        this.parsedJobPosting = JSON.parse(this.content);
      } catch (e) {
        this.parsedJobPosting = null;
        console.error(this.t.HEADER_JOB_POSTING, e);
      }
    }
  }

  parseCoverLetterIfApplicable(): void {
    if (this.type === 'from_assistant_tailored_cover_letter') {
      try {
        if (this.content) {
          const parsedData = JSON.parse(this.content);
          this.coverLetter = parsedData;
        }
      } catch (error) {
        console.error(this.t.HEADER_ASSISTANT, error);
      }
    }
  }
  openCoverLetterInNewTab(): void {
    // Assuming '/cover-letter' is the route for the cover letter component
    // const coverLetterURL =
    //   '/cover-letter?data=' +
    //   encodeURIComponent(JSON.stringify(this.coverLetter));
    // window.open(coverLetterURL, '_blank');
  }
  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.content)
      .then(() => {
        this.isCopied = true;
        console.log(this.t.TOOLTIP_COPIED);
        this.cdr.detectChanges(); // Manually trigger change detection
        setTimeout(() => {
          this.isCopied = false; // Reset after showing message
          this.cdr.detectChanges();
        }, 2000); // Tooltip and icon revert after 2 seconds
      })
      .catch((err) => {
        console.error(this.t.TOOLTIP_COPY_TO_CLIPBOARD, err);
      });
  }

  getHeaderText(type: string): string {
    switch (type) {
      case 'from_assistant':
      case 'from_assistant_tailored_cover_letter':
        return this.t.HEADER_ASSISTANT;
      case 'from_assistant_job_posting':
        return this.t.HEADER_JOB_POSTING;
      case 'from_system':
        return this.t.HEADER_SYSTEM;
      case 'from_user':
        return this.t.HEADER_YOU;
      case 'Error':
        return this.t.HEADER_ERROR;
      default:
        return this.t.HEADER_UNKNOWN;
    }
  }
}
